import { render, staticRenderFns } from "./HighThcHarvests.vue?vue&type=template&id=c7a1a530"
import script from "./HighThcHarvests.vue?vue&type=script&lang=js"
export * from "./HighThcHarvests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports